import { Id, Json, JsonEntity } from '@homeleite/arch';

export class Country implements JsonEntity {
  constructor(public id = Id.gen(), public name = '', public acronym = '') {}

  toJson() {
    return Json.to.simple(this);
  }

  static fromJson(json: any) {
    return Json.from.simple(json, Country);
  }
}

export class UF {
  constructor(
    public id = Id.gen(),
    public name = '',
    public acronym = '',
    public active = true,
    public country: Country = null
  ) {}

  toJson() {
    return Json.to.simple(this, {
      country: this.country?.toJson(),
    });
  }

  static fromJson(json: any) {
    return Json.from.simple(json, UF, {
      country: Country.fromJson(json?.country),
    });
  }
}

export class City {
  constructor(
    public id = Id.gen(),
    public name = '',
    public active = true,
    public state: UF = null
  ) {}

  toJson() {
    return Json.to.simple(this, {
      state: this.state?.toJson(),
    });
  }

  static fromJson(json: any) {
    return Json.from.simple(json, City, {
      state: UF.fromJson(json?.state),
    });
  }
}
